import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUserNotFoundStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserNotFound) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUserNotFound);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Пользователь не найден' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: пользователя нет в базе чатов, рассинхрон данных',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
